<!-- <footer class="footer fixed-bottom bg-dark text-white-50">
  <div class="container text-center">
    <small class="px-4">Copyright &copy; EY</small>
    <span class="text-muted">
      <a href="{{ apiDocsUrl }}/swagger" target="_blank" title="Api Documentation"><small>Api doc</small></a></span>
  </div>
</footer> -->
<div class="row">
  <div class="col-6">
    <p>©{{ thisYear }} EY All rights reserved. </p>
  </div>
  <div class="col-6 text-end">
    <p class="text-muted">v{{version}}</p>
  </div>
</div>


